<template>
  <div class="main">
    <div class="banner">
      <img
        src="https://static.medsci.cn/public-image/ms-image/8fa738a0-53e1-11eb-9981-415d39409db0_cbanner.png"
        alt=""
      />
    </div>
    <div class="content">
      <!-- 导语模块 -->
      <div class="daoyu">
        <div class="daoyu_top">
          <h2>导语</h2>
          <i></i>
        </div>
        <div class="daoyu_botm">
          IsoPlexis的单细胞细胞内蛋白质组解决方案源自加州理工学院的多个实验室，所有实验室都在寻求更好的方法来监控癌细胞中的蛋白质-蛋白质相互作用，目的是开发针对性的治疗方法。
          使用Western印迹，质谱和流式细胞仪等传统方法，在给定时间只能跟踪两种蛋白质类型。
          利用新发布的Isoplexis系统，研究人员可以监控30种或更多的蛋白质通路，并在同一天获得结果。
          在以前的技术中，磷酸化被用于鉴定单个蛋白质的功能，而没有关于它们如何协同工作的见解。
          单细胞细胞内蛋白质组以相同的方式揭示了该功能，但也能够提供整个蛋白质信号传导途径的背景信息，从而揭示了网络如何整体运作。了解细胞通路的整个网络可以使研究人员更好地了解异常细胞的下游效应。在癌症中，这种方法有助于评估靶向治疗（例如抗体疗法或小分子药物）的功效。
        </div>
      </div>
      <!-- 公司与产品 -->
      <div class="person pubcss">
        <div class="person_top pubcss_top">
          <img
            class="person_top_img pubcss_top_img"
            src="../assets/hh/tapic1.png"
            alt=""
          />
          <span>公司和产品</span>
          <i class="line"></i>
          <div class="clear" style="clear: both"></div>
        </div>
        <div class="person_botm">
          <p class="person_botm_right">
            IsoPlexis
            <a href="http://www.isoplexis.com">(www.isoplexis.com)</a
            >，通过其独特关联的、备受赞誉的单细胞蛋白组学系统，专注加速攻克癌症和一系列世界上最棘手的疾病。通过揭示小细胞亚群中独特的免疫生物标志物，我们将免疫治疗和靶向治疗推进到一个更加精确和个性化的阶段。在制定解决方案来攻克复杂疾病带来的挑战时，我们屡获殊荣的集成系统在全球范围内被用于推进免疫生物学和生物标志物领域的发展。
          </p>
        </div>
      </div>
      <!-- 人物专访 -->
      <div class="person pubcss">
        <div class="person_top pubcss_top">
          <img
            class="person_top_img pubcss_top_img"
            src="../assets/hh/tapic2.png"
            alt=""
          />
          <span>人物专访</span>
          <i class="line"></i>
          <div class="clear" style="clear: both"></div>
        </div>
        <div class="person_botm">
          <p class="person_botm_left">
            <img
              src="https://static.medsci.cn/public-image/ms-image/57aba5b0-5181-11eb-9981-415d39409db0_person.jpg"
              alt=""
            />
          </p>
          <p class="person_botm_right">
            肖恩·麦凯（Sean
            Mackay）是Isolexis的联合创始人，并担任首席执行官。IsoPlexis的任务是提供可广泛获取的细胞蛋白质组，以加速个性化的治疗药物。该公司专注于将细胞和基因治疗、癌症免疫学和传染病的范式转向更具患者特异性、持久性的治疗。IsoPlexis易于使用的仪器和软件赢得了众多奖项，并在全球范围内用于推进精准医疗。<br />
            在此之前，肖恩帮助孵化了克莱纳珀金斯支持的Lifesquare，该公司通过共享必要的医疗信息将患者、付款人和提供者联系起来。此外，通过在Lazard和几家早期风险投资企业的工作，他培养了一种热情，帮助生命科学和医疗器械公司在战略变革时期进行管理，为临床生态系统提供他们急需的产品。肖恩与人合著了许多围绕免疫药物的出版物，并在世界范围内拥有许多单细胞产品的专利。
          </p>
        </div>
      </div>
      <!-- 研究领域 -->
      <div class="zhipu pubcss">
        <div class="person_top pubcss_top">
          <img
            class="person_top_img pubcss_top_img"
            src="../assets/hh/tapic3.png"
            alt=""
          />
          <span>研究领域</span>
          <i class="line"></i>
          <div class="clear" style="clear: both"></div>
        </div>
        <div class="zhipu_botm">
          <div
            class="item"
            v-for="item in duList"
            :key="item.id"
            @click="linkUrl(item.url, item.id)"
          >
            <img :src="item.image_url" alt="" />
            <h3>{{ item.title }}</h3>
            <div>{{ item.desc }}<span class="liaoPlus">了解详情</span></div>
          </div>
        </div>
      </div>
      <!-- 所获奖项 -->
      <div class="person pubcss">
        <div class="person_top pubcss_top">
          <img
            class="person_top_img pubcss_top_img"
            src="../assets/hh/tapic4.png"
            alt=""
          />
          <span>所获奖项</span>
          <i class="line"></i>
          <div class="clear" style="clear: both"></div>
        </div>
        <div class="person_botm">
          <p class="person_botm_left">
            <img
              src="https://static.medsci.cn/public-image/ms-image/20c28340-5189-11eb-9981-415d39409db0_huojiang.jpg"
              alt=""
            />
          </p>
          <p class="person_botm_right">
              爱迪生奖(Edison
            Awards)于1987年有美国电机电子工程师学会特设立，该奖项以发明家托马斯·爱迪生命名，旨在表彰世界最优秀的创新者和创新成果。目前爱迪生奖已经成为全球产品服务的创新、设计领域最富盛名的奖项。爱迪生奖的获得者是由全球3000多名顶级学者，获奖者，及业界的领导者组成的专业评审团通过投票选出，仅颁给科技界最创新、最杰出和最具国际影响力的产品和企业家，苹果公司创始人Steven
            Jobs(史蒂夫·乔布斯)、宝洁公司创始人兼CEO
            A.G.Lafley(阿兰·乔治·雷夫利)，特斯拉创始人Elon
            Musk(埃隆·马斯克)等人都曾获得过该奖，爱迪生奖也因此被誉为科技创新界的最高荣誉之一，“The
            Oscar of Innovation（创新界的奥斯卡）”<br />
            IsoSpark是一个适合各实验室的个性化、自动化蛋白质组学检测系统。利用创新技术将“软件支持的光学系统、流体动力学支持的流通池、硬件与软件的深层连接”整合到大小仅为18英寸（45.7厘米）的系统中，易于使用，而且可以当天出结果。
          </p>
        </div>
      </div>
      <!-- 信息资源 -->
      <div class="info pubcss">
        <div class="person_top pubcss_top">
          <img
            class="person_top_img pubcss_top_img"
            src="../assets/hh/tapic5.png"
            alt=""
          />
          <span>信息资源</span>
          <i class="line"></i>
          <div class="clear" style="clear: both"></div>
        </div>
        <div class="info_botm">
          <div
            class="info_botm_one info_public public_special"
            style="margin-top: 15px"
          >
            <div class="public_top">
              <img
                class="info_icon"
                src="../assets/pc/download.png"
                alt=""
              /><span class="hh">资料下载：</span>
            </div>
            <div class="tpp" v-for="item in downList" :key="item.id">
              <img src="../assets/pc/road.png" alt="" />
              <div>
                {{ item.title }}<i @click="getDio(item.id, item.url)">下载</i>
              </div>
            </div>
          </div>
          <div class="info_botm_one"></div>
          <div class="info_public" style="margin-top: 0.15rem">
            <div class="public_top">
              <img
                class="info_icon"
                src="../assets/pc/wenxian.png"
                alt=""
              /><span class="hh">文献解读：</span>
            </div>
            <div
              class="tpp"
              v-for="item in wenxianList"
              :key="item.id"
              @click="linkUrl(item.url, item.id)"
            >
              <img src="../assets/pc/road.png" alt="" />
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 互动与联系 -->
      <div class="lianxi pubcss">
        <div class="fluidigm_top pubcss_top">
          <img
            class="person_top_img pubcss_top_img"
            src="../assets/pc/tapic6.png"
            alt=""
          />
          <span>互动与联系</span>
          <i class="line"></i>
          <div class="clear" style="clear: both"></div>
        </div>
        <div class="lianxi_botm">
          <div class="lianxi_top">
            <h2>
              感谢关注IsoPlexis，欢迎录制视频，记录您想对IsoPlexis说的话。视频可通过微信或邮件发给如下联系人。如需咨询或产品预订，请联系
            </h2>
            <div> <img class="pub_img" src="../assets/pc/adress.png" />联系人： Shek Ting Wong (黃硕廷)</div>
            <div> <img  class="pub_img" src="../assets/pc/emial.png" />邮箱：Shek.wong@isoplexis.com </div>
            <div><img class="pub_img" src="../assets/pc/iphone.png" />电话：  +65-9114-6308</div>
            <div>
              <img class="pub_img" src="../assets/pc/adress.png" />总部地址：35 North East Industrial Road, Branford, CT 06405              
            </div>
            <div @click="linkUrl('https://www.isoplexis.com')">
             <img  class="pub_img" src="../assets/pc/wangzhi.png" />
              网站： www.isoplexis.com
            </div>
            <div @click="linkUrl('https://isoplexis.com/contact/')">
              <img class="pub_img" src="../assets/pc/wangzhi.png"  />
              留言： https://isoplexis.com/contact/
            </div>
          </div>
          <div class="lianxi_bottom">
            <img
              src="https://static.medsci.cn/public-image/ms-image/da420de0-518e-11eb-9981-415d39409db0_erweima.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      downList: [
        {
          id: 1,
          url:
            "https://7n-m-visitor.medsci.cn/%E4%BA%A7%E5%93%81%E6%89%8B%E5%86%8C2020_IsoSpark%C2%A0Brochure%C2%A0Final%C2%A000_ZHCN_jr.pdf",
          title: "IsoSpark 中文产品手册",
        },
        {
          id: 2,
          url:
            "https://7n-m-visitor.medsci.cn/%E3%80%8A%E8%87%AA%E7%84%B6-%E9%80%9A%E8%AE%AF%E3%80%8B%E6%96%B0%E4%BD%9C%EF%BC%9A%E6%94%B9%E5%96%84%E8%BF%87%E7%BB%A7%E5%85%8D%E7%96%AB%E7%BB%86%E8%83%9E%E8%BE%93%E6%B3%A8%EF%BC%9A%E6%96%B0%E7%9A%84%E7%BB%84%E5%90%88%E4%BA%A7%E7%94%9F%E6%9B%B4%E5%A5%BD%E7%9A%84%E7%96%97%E6%95%88.pdf",
          title:
            "《自然-通讯》新作：改善过继免疫细胞输注：新的组合产生更好的疗效",
        },
        {
          id: 3,
          url:
            "https://7n-m-visitor.medsci.cn/%E3%80%8A%E8%A1%80%E6%B6%B2%E8%BF%9B%E5%B1%95%E3%80%8B%E6%96%B0%E7%A0%94%E7%A9%B6.pdf",
          title:
            "《血液进展》新研究：切断逃逸路径：三聚体双靶向CAR瞄准多发性骨髓瘤",
        },
      ],
      wenxianList: [
        {
          id: 1,
          url: "https://isoplexis.com/science-education/publications/",
          title: "IsoPlexis Publications 文献",
        },
        {
          id: 2,
          url:
            "https://isoplexis.com/science-education/webinars/#single-cell-webinars",
          title: "webinar在线讲座",
        },
        {
          id: 3,
          url:
            "https://isoplexis.com/support-resources/introducing-the-new-isospark-product-sheet/",
          title: "IsoSpark Product Sheet 产品列表",
        },
        {
          id: 4,
          url:
            "https://isoplexis.com/support-resources/introducing-the-new-isospark-brochure/",
          title: "IsoSpark Brochure产品手册",
        },
        {
          id: 5,
          url: "https://isoplexis.com/webinars/shifting-space-and-time/",
          title: "IsoSpark Launch Webinar 美国区产品发布直播",
        },
      ],
      jiangzuoList: [],
      ziXunList: [],
      duList: [
        {
          id: 1,
          url:
            "https://isoplexis.com/research-areas/checkpoint-combination-immunotherapies/",
          image_url:
            "https://static.medsci.cn/public-image/ms-image/a1576630-5182-11eb-9981-415d39409db0_mian.jpg",
          title: "肿瘤免疫",
          desc:
            "Isoplexis对于液体T细胞活组织检查的功能性免疫全景，通过独特洞察显示了哪些疗法对哪些患者有效。",
        },
        {
          id: 2,
          url: "https://isoplexis.com/research-areas/cell-therapy/",
          image_url:
            "https://static.medsci.cn/public-image/ms-image/8071cf40-5183-11eb-9981-415d39409db0_liao.jpg",
          title: "细胞疗法",
          desc:
            "用IsoPlexis的功能性免疫全景来进行质量分析正在塑造细胞治疗的未来。Isoplexis能够帮助实现更有效的生产，更高质量的细胞疗法，来改善患者的治疗效果。",
        },
        {
          id: 3,
          url:
            "https://isoplexis.com/research-areas/vaccines-and-immunology-research/",
          image_url:
            "https://static.medsci.cn/public-image/ms-image/d6224d70-5183-11eb-9981-415d39409db0_ran.jpg",
          title: "传染病",
          desc:
            "COVID-19和其他复杂疾病正通过IsoPlexis的功能性免疫全景和高复杂度的自动化免疫分析产品来加速研究。",
        },
        {
          id: 4,
          url:
            "https://isoplexis.com/research-areas/inflammatory-auto-immune-disease/",
          image_url:
            "https://static.medsci.cn/public-image/ms-image/1a86b1e0-5184-11eb-9981-415d39409db0_yan.jpg",
          title: "炎症",
          desc:
            "IsoPlexis的高复杂度免疫分析和功能性免疫全景提供了对免疫炎症的驱动因子的即时洞察。",
        },
        {
          id: 5,
          url: "https://isoplexis.com/research-areas/solid-tumor-oncology/",
          image_url:
            "https://static.medsci.cn/public-image/ms-image/562f85a0-5184-11eb-9981-415d39409db0_zhi.jpg",
          title: "靶向治疗",
          desc:
            "IsoPlexis的细胞内信号组揭示了导致耐药性的功能性细胞适应机制，并为开发更好的靶向治疗提供了见解。",
        },
      ],
    };
  },
  methods: {
    // 点击下载弹框
    getDio(id, url) {
      window.location.href = url;
    },
    //链接
    linkUrl(url, id) {
      if (url) {
        window.location.href = url;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.clearfix::after {
  content: "";
  display: block;
  line-height: 0;
  clear: both;
}
.main {
  height: 100%;
  background: #f7f7f7;
  .banner {
    height: 3.2rem;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
  .content {
    padding: 0 0.21rem 0.2rem 0.23rem;
    .daoyu {
      margin-top: 0.25rem;
      border-radius: 0.1rem;
      background: linear-gradient(#e6f4fc, #fdfefe);
      box-shadow: 0px 2px 0.03rem 0px rgba(0, 0, 0, 0.16);
      padding: 0.3rem 0.26rem 0.46rem 0.32rem;
      .daoyu_top {
        font-size: 0.3rem;
        color: #0073a4;
      }
      i {
        display: inline-block;
        width: 100%;
        height: 3px;
        background: linear-gradient(to right, #1b9adc, #edf7fc);
        margin-top: 0.2rem;
        margin-bottom: 0.22rem;
      }
      .daoyu_botm {
        font-size: 0.24rem;
        color: #666666;
        text-indent: 2em;
      }
    }
    .pubcss {
      background: #ffffff;
      border-radius: 0.1rem;
      padding: 0px 0.14rem 0.17rem 0.22rem;
      box-sizing: border-box;
      margin-top: 0.2rem;
      position: relative;
      .pubcss_top {
        padding-left: 1.23rem;
        padding-top: 0.15rem;
        span {
          font-size: 0.28rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Bold;
          font-weight: 700;
          text-align: left;
          float: left;
          color: #006aab;
        }
        i {
          display: inline-block;
          width: 100%;
          height: 1px;
          float: left;
          margin: 0.19rem 0 0.24rem 0;
          border-bottom: 1px dashed #008dcd;
        }
        .pubcss_top_img {
          position: absolute;
          top: 0;
          left: 0;
          width: 1.39rem;
          height: 0.84rem;
          vertical-align: middle;
        }
      }
      .person_botm {
        // margin-top:0.15rem;
        display: flex;
        justify-content: flex-start;
        .person_botm_left {
          width: 0.86rem;
          height: 0.86rem;
          margin-right: 0.43rem;
          // background: #b0daf0;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
        .person_botm_right {
          width: 90%;
          font-size: 0.24rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
        }
      }
    }
    .zhipu {
      .zhipu_botm {
        .item {
          padding: 0.36rem 0 0.35rem 0;
          border-bottom: 1px dashed #d3d3d3;
        }
        img {
          width: 100%;
          height: 4.37rem;
          vertical-align: middle;
        }
        h3 {
          font-size: 0.28rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
          font-weight: 600;
          text-align: left;
          color: #333333;
          margin: 0.2rem 0 0.2rem 0;
        }
        div {
          font-size: 0.24rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
        }
      }
    }
    .info {
      .info_botm {
        .info_public {
          position: relative;
          padding-top: 0.6rem;
          .public_top {
            position: absolute;
            top: -0.5rem;
            left: 0;
          }
          .info_icon {
            width: 0.29rem;
            height: 0.35rem;
            margin-right: 3px;
            vertical-align: middle;
          }
          .hh {
            font-weight: 600;
            color: #333;
            font-size: 0.24rem;
            vertical-align: middle;
          }
          .tpp {
            img {
              width: 0.2rem;
              height: 0.2rem;
              vertical-align: middle;
              margin-right: 0.21rem;
            }
            margin-bottom: 10px;
            font-size: 0.24rem;
            font-weight: 400;
            text-align: left;
            color: #666666;
            div {
              display: inline-block;
              width: 90%;
              vertical-align: middle;
            }
          }
        }
        .info_botm_one {
          border-bottom: 1px dashed #d3d3d3;
        }
        .public_special {
          border-bottom: 0 none;
          .tpp i {
            margin-left: 5px;
            display: inline-block;
            // width: 0.77rem;
            // height: 0.32rem;
            // line-height: 0.32rem;
            padding: 0.05rem 0.2rem;
            text-align: center;
            background: #0081c1;
            border-radius: 10px;
            color: #fff;
            font-size: 0.2rem;
          }
        }
      }
    }
    .lianxi {
      .pub_img {
        width: 12px;
        height: 14px;
        vertical-align: middle;
        margin-right: 6px;
      }
      .lianxi_botm h2 {
        font-size: 0.24rem;
        font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
        font-weight: 600;
        text-align: left;
        color: #333333;
      }
      .lianxi_botm div {
        font-size: 0.24rem;
        font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
        font-weight: 400;
        text-align: left;
        color: #666;
        margin: 0.31rem 0;
      }
      .lianxi_bottom {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        div {
          margin: 0;
        }
        img {
          widows: 3.39rem;
          height: 3.39rem;
          vertical-align: middle;
        }
      }
    }
  }
}
.liaoPlus {
  color: #1b9adc !important;
  cursor: pointer;
}
</style>
